import { selectAllVariants } from '@ff-scene-plugins/photo-prints-redux/selectors/variantSelectors';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import cuid from 'cuid';

export const toGroupIfVariantExists = (
    state: PhotoPrintsPdpState, paperId: string, sizeId: string, groupId = cuid()
): PhotoPrintsJson.Group | undefined => {

    const variants = selectAllVariants(state);
    const variant = variants
        .find(v => v!.paperId === paperId && v!.sizeId === sizeId);

    if (variant) {
        return {
            id: groupId,
            variantId: variant.id,
            amountInQueue: 0
        };
    }
};